<template>
  <scroll-center-dialog v-model="open" :loading="loading" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-form ref="form" class="user_dialog__fields">
      <div class="field_label__text">РЕГИОН:</div>
      <v-autocomplete
          class="dialog__fields"
          color="#3254B9"
          base-color="#313743"
          variant="solo"
          item-title="text"
          item-value="value"
          no-data-text="Нет подходящих данных"
          placeholder="Начните вводить назва..."
          :rules="[rules.not_null]"
          :items="selectors.regions"
          v-model="data.region"
          :loading="loading"
          :error="hasError('region')"
          :error-messages="getError('region')"
      >
      </v-autocomplete>
      <div class="field_label__text">НАСЕЛЕННЫЙ ПУНКТ:</div>
      <v-text-field
          class="dialog__fields"
          color="#3254B9"
          base-color="#313743"
          variant="solo"
          :rules="[rules.not_null]"
          v-model="data.city"
          :loading="loading"
          :error="hasError('city')"
          :error-messages="getError('city')"
      >
        <template v-slot:label></template>
      </v-text-field>
      <div class="field_label__text">ТЕЛЕФОН:</div>
      <v-text-field
          class="dialog__fields"
          color="#3254B9"
          base-color="#313743"
          variant="solo"
          :rules="[rules.phone]"
          v-maska:[phone_options]
          v-model="data.phone"
          :loading="loading"
          :error="hasError('phone')"
          :error-messages="getError('phone')"
      >
        <template v-slot:label></template>
      </v-text-field>
  <!--    <div class="field_label__text">ТЕКУЩИЙ ПАРОЛЬ:</div>-->
  <!--    <v-text-field-->
  <!--        class="dialog__fields"-->
  <!--        color="#3254B9"-->
  <!--        base-color="#313743"-->
  <!--        variant="solo"-->
  <!--        v-model="data.password"-->
  <!--        :loading="loading"-->
  <!--        :error="hasError('password')"-->
  <!--        :error-messages="getError('password')"-->
  <!--    >-->
  <!--      <template v-slot:label></template>-->
  <!--    </v-text-field>-->
    </v-form>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog"
import { mapActions } from "vuex"
import { vMaska } from "maska"

export default {
  name: "UserInfoDialog",
  props: {
    value: Boolean,
    member: Object
  },
  components: {
    ScrollCenterDialog,
  },
  directives: { maska: vMaska },
  mixins: [FormErrorsMixin],
  data () {
    return {
      open: false,
      loading: false,
      phone_options: {
        mask: "+# (###) ###-##-##",
        eager: true
      },
      data: {
        region: '',
        city: '',
        phone: '',
        // password: ''
      },
      selectors: {
        regions: [],
      },
      rules: {
        phone: value => {
          if (value !== '') {
            const pattern = /^\+7[ ]\(\d{3}\)[ ]\d{3}-\d{2}-\d{2}$/
            return pattern.test(value) || 'Некорректный ввод'
          }
        },
        not_null: value => {
          if (value !== undefined) {
            return (value !== null && value.toString().trim().length > 0) || 'Поле не может быть пустым'
          } else {
            return 'Обязательное поле'
          }
        },
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.open = this.value
      }
    },
    open: {
      immediate: true,
      handler () {
        this.$emit('input', this.open)
      }
    }
  },
  computed: {
    form_title () {
      return 'ИНФОРМАЦИЯ УЧАСТНИКА'
    },
  },
  methods: {
    ...mapActions({
      updateMember: 'personal_account/members/updateMember',
      loadRegions: 'selectors/loadRegions',
    }),
    async save () {
      const { valid } = await this.$refs.form.validate()

      if (valid) {
        this.send()
      }
    },
    send () {
      this.loading = true
      this.updateMember({
        id: this.data.id,
        data: this.data,
        finalizer: () => {
          this.$emit('save')
          this.loading = false
        },
        catcher: (val) => {
          this.mapErrors(val)
          this.loading = false
        },
      })
    },
    loadSelectors () {
      this.loadRegions({
        url: undefined,
        finalizer: (val) => {
          this.selectors.regions = val
        }
      })
    },
    loadData () {
      if (this.member !== undefined) {
        for (const key of Object.keys(this.member)) {
          // eslint-disable-next-line
          if (this.data.hasOwnProperty(key)) {
            this.data[key] = this.member[key]
          }
        }
        this.data.id = this.member.id
        this.data.region = this.member.region.id
      }
    },
    close () {
      this.$emit('close')
    },
  },
  created () {
    this.loadData()
    if (this.selectors.regions.length === 0) {
      this.loadSelectors()
    }
  }
}
</script>

<style scoped lang="scss">
.dialog__fields {
  margin-bottom: 5px;
}

.field_label__text {
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  color: #3254B9;
}

@media screen and (max-width: 768px) {
  .field_label__text {
    font-size: 12px;
    line-height: 15px;
  }
}
</style>
